import { apiGet, apiPost } from './client';
import type { AiPlugin, OperationResult, PagedItemsResult } from './types';

export interface PluginSearchParams {
  search?: string;
  /** When true, the server returns ONLY plugins with a non-empty UserTypes (globals). */
  globals?: boolean;
  pageNo?: number;
  pageSize?: number;
}

export async function searchPlugins(
  params: PluginSearchParams = {}
): Promise<PagedItemsResult<AiPlugin>> {
  const { search = '', pageNo = 1, pageSize = 100, globals } = params;
  const wrapped = await apiGet<OperationResult<PagedItemsResult<AiPlugin>>>(
    '/api/AiPlugin/Search',
    { search, pageNo, pageSize, globals }
  );
  if (!wrapped.isSuccess || !wrapped.data) {
    throw new Error(wrapped.message || 'Failed to load plugins');
  }
  return wrapped.data;
}

/**
 * Save a tool's editable metadata (today: description). Sends the full row so
 * the backend's whole-entity Update does not null out Name / Title / UserTypes —
 * pass the plugin you loaded, with only the fields you changed replaced.
 *
 * Backend: POST /api/AiPlugin/Update → base.Update(model). Returns the saved row.
 */
export async function updatePlugin(model: AiPlugin): Promise<AiPlugin> {
  const wrapped = await apiPost<OperationResult<AiPlugin>>('/api/AiPlugin/Update', model);
  if (!wrapped.isSuccess) {
    throw new Error(wrapped.message || 'Failed to save the tool');
  }
  return wrapped.data ?? model;
}
